import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';

@Component({
  selector: 'kendo-grid-cell-color',
  template: `
    <div class="label-color" [style.backgroundColor]="getColor(color)">
      {{ (text=='') ? color_str: text }}
    </div>`,
  styles: [`
    .label-color {
      text-align: center;
      color: #fff;
      padding: 0 4px 0 4px;
    }`],
})
export class KendoGridCellColorComponent implements OnInit {

  @Input() color: string;
  @Input() text: string = '';

  protected color_str: string;

  constructor(private sanitizer: DomSanitizer) { }

  protected getColor(s: string): SafeStyle {  

    this.color_str = '#' + s;
    return this.sanitizer.bypassSecurityTrustStyle(this.color_str);

  }

  ngOnInit() {
  }

}
